module.exports = __webpack_public_path__ + "img/uiux.d9d1c474.svg";